import { useEffect, useRef, useState } from 'react';
import { searchCircles } from '../../api/circles';
import { message } from './circle_helpers';

function useSearch(query, page, refresh, { visibility = 'all', placement = '' } = {}) {
  const [state, setState] = useState({ circles: [], loading: true, hasMore: false, error: '' });
  const latest = useRef(0);
  const scope = useRef(null);
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    const request = ++latest.current;
    const key = JSON.stringify([query, refresh, visibility, placement]);
    const keepResults = page > 0 && scope.current === key;
    scope.current = key;
    setState(old => ({ circles: keepResults ? old.circles : [], loading: true, hasMore: false, error: '' }));
    const timer = setTimeout(
      () =>
        searchCircles(query, page, { visibility, placement })
          .then(data => {
            if (request === latest.current) {
              setState(old => ({
                ...data,
                circles: keepResults ? [...new Map([...old.circles, ...data.circles].map(circle => [circle.id, circle])).values()] : data.circles,
                loading: false,
                error: ''
              }));
            }
          })
          .catch(error => {
            if (request === latest.current) setState(old => ({ ...old, loading: false, hasMore: false, error: message(error) }));
          }),
      250
    );
    return () => {
      clearTimeout(timer);
      latest.current++;
    };
  }, [query, page, refresh, retry, visibility, placement]);
  const replaceCircle = circle => setState(old => ({ ...old, circles: old.circles.map(row => (row.id === circle.id ? circle : row)) }));
  return { ...state, replaceCircle, retry: () => setRetry(value => value + 1) };
}

export default useSearch;
